<template>
    <div class="">
        <group-page-header title="Group Activity"></group-page-header>
        <div class="form margin-10-top" v-if="canCreatePosts">
            <add-activity-panel
                    holder="Type here to update your Group"
                    :allow-add-to-diary="false"
                    :allow-add-to-other-users-diary="false"
                    @onSave="onSave"
            ></add-activity-panel>
        </div>
        <render-activity-feed
                :activity-entry-point="activityEntryPoint"
        >
        </render-activity-feed>
    </div>
</template>

<script>
    import Vue from "vue";
    import _ from 'lodash';
    import {CurrentUserClass} from "shared/CurrentUser";
    import {ACTIVITY_BUS_EVENTS, activityEventsBus} from "../activity/activityEventsBus";
    import {mapGetters} from "vuex";
    import GroupPageHeader from "./common/GroupPageHeader";

    export default {
        name: "GroupPageActivity",
        components: {
            GroupPageHeader,
            AddActivityPanel: () => import(/* webpackChunkName: "activityFeed" */ "../activity/AddActivityPanel"),
            RenderActivityFeed: () => import(/* webpackChunkName: "activityFeed" */ "../activity/RenderActivityFeed")
        },
        props: {},
        computed: {
            ...mapGetters('groupPage', {group: 'group'}),
            activityEntryPoint() {
                const SiteActivityResource = Vue.getAngularModule('SiteActivityResource');
                return _.partial(SiteActivityResource.get_group_activity, this.group.id);
            },
            canCreatePosts() {
                const CurrentUser = new CurrentUserClass();
                return CurrentUser.has_permission('create-posts');
            },
        },
        methods: {
            onSave(activityPostData) {
                const $rootScope = Vue.getAngularModule('$rootScope');
                const GroupActivityPostResource = Vue.getAngularModule('GroupActivityPostResource');
                $rootScope.show_dimmer();
                GroupActivityPostResource.create_post(this.group.id, activityPostData)
                    .then(resp => {
                        let newActivity = resp.data;
                        activityEventsBus.$emit(ACTIVITY_BUS_EVENTS.ACTIVITY_POST_CREATED, newActivity);
                        Vue.notifications.success('Created');
                    }, err => {
                        Vue.notifications.error(err || 'Error');
                    })
                    .finally($rootScope.hide_dimmer);
            }
        }
    };
</script>

<style lang="scss" scoped>
  @import "commonStyle";
</style>